export const settingImg = 'https://admin.komdaam.com/assets/images/setting/'
export const categoryImg = 'https://admin.komdaam.com/assets/images/category/'
export const sliderImg = 'https://admin.komdaam.com/assets/images/slider/'
export const productImg = 'https://admin.komdaam.com/assets/images/product/'
export const bannerImg = 'https://admin.komdaam.com/assets/images/banner/'
export const testimonialImg = 'https://admin.komdaam.com/assets/images/testimonials/'
export const profileImg = 'https://admin.komdaam.com/assets/images/img/'


export const campaignImg = 'https://admin.komdaam.com/assets/images/campaign/'
export const blogImg = 'https://admin.komdaam.com/assets/images/blog/'
export const offerImg = 'https://admin.komdaam.com/assets/images/offer/'